/* eslint-disable import/no-anonymous-default-export */
export default {
  apiInstanceNotInitialized: 'ApiPromise is not initialized',
  noArgumentsProvidedBalanceQuery:
    'No Arguments have been provided to the balance query',
  missingArgumentsLockedBalanceQuery:
    'One or more arguments missing to the locked balance query',
  invalidTransferVariables: 'Invalid transfer parameters provided',
  usableBalanceNotAvailable: 'Unable to determine usable balance',
  vestingScheduleIncomplete:
    'Vesting schedule has at least one undefined property'
}
